import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    customer: Yup.string().required('Customer field is required'),
    invoice_date: Yup.date().required('Invoice date is required'),
    due_date: Yup.date().nullable(),
    line_items: Yup.array()
        .of(
            Yup.object().shape({
                description: Yup.string().required('Description is required'),
                quantity: Yup.number().min(0.01, 'Quantity must be greater than 0').required('Quantity is required'),
                unit_amount: Yup.number().min(0, 'Unit amount must be 0 or greater').required('Unit amount is required'),
                account_code: Yup.string().required('Account code is required'),
                tax_type: Yup.string().required('Tax type is required'),
            })
        )
        .min(1, 'At least one line item is required'),
})
